"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles2 = require("../../styles");

var _styles;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SCALE_ANIMATION_ID = 'tempus-loader-scale';
var SPIN_ANIMATION_ID = 'tempus-loader-spin';
var styles = (_styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: function width(_ref) {
      var scale = _ref.scale;
      return "".concat(Math.floor(35 * scale), "px");
    },
    height: function height(_ref2) {
      var scale = _ref2.scale;
      return "".concat(Math.floor(35 * scale), "px");
    },
    overflow: 'hidden',
    transition: '0.8s background-color'
  },
  spinner: {
    border: function border(_ref3) {
      var scale = _ref3.scale;
      return "".concat(2 * scale, "px solid ").concat(_styles2.colors.gray);
    },
    borderLeftColor: function borderLeftColor(_ref4) {
      var color = _ref4.color;
      return color;
    },
    animation: "".concat(SPIN_ANIMATION_ID, " 1.2s linear infinite")
  },
  complete: {
    background: function background(_ref5) {
      var color = _ref5.color;
      return color;
    }
  },
  checkSvg: {
    height: 'inherit',
    width: 'inherit',
    borderRadius: '50%',
    strokeWidth: 3,
    stroke: _styles2.colors.white,
    animation: "".concat(SCALE_ANIMATION_ID, " .3s ease-in-out .5s both")
  }
}, _defineProperty(_styles, "@keyframes ".concat(SPIN_ANIMATION_ID), {
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
}), _defineProperty(_styles, "@keyframes ".concat(SCALE_ANIMATION_ID), {
  '0%, 100%': {
    transform: 'none'
  },
  '50%': {
    transform: 'scale3d(1.2, 1.2, 1)'
  }
}), _styles);
var _default = styles;
exports["default"] = _default;